.SuggestionContainer {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: var(--space-sm);
  align-items: center;

  .SuggestionImage {
    display: grid;
    grid: auto / auto;
    place-items: center;
    width: 36px;
    aspect-ratio: 1;
    border: 2px solid transparent;
    transition: border-color 0.2s;

    img {
      width: auto;
      max-height: 30px;
    }
  }

  .SuggestionNameLink {
    display: inline-flex;
    gap: var(--space-xs);
    cursor: pointer;
    border-radius: 2px;
    width: fit-content;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      color: var(--primary);
    }

    &:focus-visible,
    &:global(.focus-visible) {
      outline: 2px solid var(--primary);
      outline-offset: 2px;
      text-decoration: underline;
    }

    & > [data-slot="icon"] {
      min-width: fit-content;
    }
  }

  .TooltipContent {
    min-width: 250px;
    white-space: normal;
  }
}
